<template>
  <div class="app-container">
    <span style="font-size:18px;font-weight:bold">车辆类型管理</span>
    <hr style="margin-top: 5px;border:1px solid #bababa" />
    <div>
      <el-button class="filter-item btn-car-type" style="margin-top: 10px;" type="primary" icon="el-icon-plus"
        @click="handleCreate">
        新建
      </el-button>
      <el-input class="input-type" clearable placeholder="请输入车辆类型名称" prefix-icon="el-icon-search" maxlength="20"
        @input="e => listQuery = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')" v-model="listQuery"
        @keyup.enter.native="setCarTypeList" :onkeyup="listQuery = listQuery.replace(/\s+/g,'')">
      </el-input>
    </div>

    <!-- 数据列表区 -->
    <el-table :data="tableData" style="width: 100%; margin:0 auto;align: center; margin-top:30px;" border
      :header-cell-style="tableHeaderColor" highlight-current-row>
      <el-table-column prop="name" label="类型名称" width="200" align="center">
      </el-table-column>
      <el-table-column prop="length" label="长度（米）" align="center">
      </el-table-column>
      <el-table-column prop="width" label="宽度（米）" align="center">
      </el-table-column>
      <el-table-column prop="height" label="高度（米）" align="center">
      </el-table-column>
      <el-table-column prop="weight" label="重量（千克）" align="center">
      </el-table-column>
      <el-table-column prop="operator" label="操作" width="100" align="center">
        <template v-slot:="{row,$index}">
          <el-select value="更多">
            <el-option v-for="(item, index) in tableOptions" :key="item" :value="index"
              @click.native="handleOperator(index, row)">
              {{item}}
            </el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <pagination-easy :total="totalCountsCar" @pagination="handlePageChangeCar" layout='prev, pager, next, jumper'
      :page="dataCarListReq.pageIndex" small :pager-count="5">
    </pagination-easy>

    <!-- 编辑车辆 -->
    <el-dialog title="新建车辆类型" :visible.sync="carTypeDialogVisable" :title="dialogTitleType ==='edit'?'编辑车辆类型':'新建车辆类型'"
      width="500px"  >
      <el-form :model="formCarTypeData" label-position="right" label-width="100px">
        <el-form-item label="类型名称:" prop="addtypeName">
          <el-input v-model="formCarTypeData.addtypeName" placeholder="请输入类型名称" maxlength="20"
            @input="e => formCarTypeData.addtypeName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="长(米):" prop="addtypeLength">
          <el-input v-model="formCarTypeData.addtypeLength" placeholder="请输入长度"
            @keyup.native="keyUpValidate(1,formCarTypeData.addtypeLength)">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="宽(米):" prop="addtypeWidth">
          <el-input v-model="formCarTypeData.addtypeWidth" placeholder="请输入宽度"
            @keyup.native="keyUpValidate(2,formCarTypeData.addtypeWidth)">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="高(米):" prop="addtypeHeight">
          <el-input v-model="formCarTypeData.addtypeHeight" placeholder="请输入高度"
            @keyup.native="keyUpValidate(3,formCarTypeData.addtypeHeight)">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="重量(千克):" prop="addtypeWeight">
          <el-input v-model="formCarTypeData.addtypeWeight" placeholder="请输入重量"
            @keyup.native="keyUpValidate(4,formCarTypeData.addtypeWeight)">
            </>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carTypeDialogVisable = false">返 回</el-button>
        <el-button type="primary" @click="createCarType()">提 交</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import paginationEasy from '@/components/common/Pagination'

  import {
    carTypeSave,
    carTypeEdit,
    getCarTypeList,
    deleteCarTypeController
  } from '@/api/car'


  export default {

    components: {
      paginationEasy
    },

    data() {
      return {

        // 查询框
        listQuery: '',

        // 车辆总数
        totalCountsCar: 30,

        //  车辆分页数据
        dataCarListReq: {
          pageIndex: 1,
          pageSize: 10,
        },

        // 错误验证标识
        error_input: false,

        carTypeDialogVisable: false,
        carTypeDialogVisableCreate: false,
        enbleSelect: true,
        tableOptions: [
          '编辑',
          '删除'
        ],
        dialogTitleType: 'create',
        formCarTypeData: {
          addtypeId: '',
          addtypeEntityId: '',
          addtypeName: '',
          addtypeLength: '',
          addtypeWidth: '',
          addtypeHeight: '',
          addtypeWeight: '',
          addtypeCarCost: '',
          addtypeInsurance: '',
          addtypeMaintenanceFees: '',
          addtypeChargingFee: '',
          addtypeInvoiceTax: '',
          addtypeDeposit: '',
          addtypeDailyFee: '',
          addtypeMonthlyFee: '',
          addtypeAnnualFee: ''
        },
        tableHeight: '',

        // 列表数据
        tableData: [],

      }
    },
    filters: {

    },
    created() {
      //  this.tableHeight = window.innerHeight - 500
    },
    methods: { // 修改table tr行的背景色
      tableRowStyle({
        row,
        rowIndex
      }) {
        return 'background-color: #f9f8ff'
      },

      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },

      // 修改table header的背景色
      tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex === 0) {
          return 'background-color: #e8e8e8;color: #000000;font-weight: 500;'
        }
      },

      /**
       * 添加列表数据
       */
      setCarTypeList() {

        if (this.listQuery === '') {

          getCarTypeList("list", this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize).then(res => {

            this.tableData = res.data;
            this.totalCountsCar = res.count;

          })
        } else {
          getCarTypeList(this.listQuery, this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize).then(res => {

            this.tableData = res.data;
            this.totalCountsCar = res.count;

          })

        }

      },

      handlePageChangeCar(data) {
        console.log("当前页", data);
        this.dataCarListReq.pageIndex = data.page
        this.dataCarListReq.pageSize = data.limit
        this.setCarTypeList();
      },

      /**
       * 处理操作
       */
      handleOperator(index, row) {
        switch (index) {
          case 0:
            // index: 0 表示编辑车辆
            this.editCarType(row)
            break;
          case 1:

            this.deleteCarType(row)
            break;
          default:
            break;
        }
      },

      /**
       * 新增按钮
       */
      handleCreate() {
        this.clearForm();
        this.dialogTitleType = 'create';
        this.carTypeDialogVisable = true;
        this.enbleSelect = false
      },

      /**
       * 校验
       */
      keyUpValidate(index, value) {
        let returnVal = value;
        // 第一个字符不能是 '.'
        let validate1 = /^\./g;
        // 只能包含数字或 '.'
        let validate2 = /[^\d.]/g;
        if (validate1.test(value)) {
          this.$message.error('第一个字符不能是   .  ');
          returnVal = "";
        } else if (validate2.test(value)) {
          this.$message.error('只能包含数字或  . ');
          returnVal = value.slice(0, value.length - 1);
        } else if (value.split('.').length - 1 > 1) {
          this.$message.error('只能含有一个 小数点');
          returnVal = value.replace(/\.{2,}/g, '') // 只保留第一个. 清除多余的
          returnVal = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        }
        switch (index) {
          case 1:
            this.formCarTypeData.addtypeLength = returnVal
            break;
          case 2:
            this.formCarTypeData.addtypeWidth = returnVal
            break;
          case 3:
            this.formCarTypeData.addtypeHeight = returnVal
            break;
          case 4:
            this.formCarTypeData.addtypeWeight = returnVal
            break;
          case 5:
            this.formCarTypeData.addtypeCarCost = returnVal
            break;
          case 6:
            this.formCarTypeData.addtypeInsurance = returnVal
            break;
          case 7:
            this.formCarTypeData.addtypeMaintenanceFees = returnVal
            break;
          case 8:
            this.formCarTypeData.addtypeChargingFee = returnVal
            break;
          case 9:
            this.formCarTypeData.addtypeInvoiceTax = returnVal
            break;
          case 10:
            this.formCarTypeData.addtypeDeposit = returnVal
            break;
          case 11:
            this.formCarTypeData.addtypeDailyFee = returnVal
            break;
          case 12:
            this.formCarTypeData.addtypeMonthlyFee = returnVal
            break;
          case 13:
            this.formCarTypeData.addtypeAnnualFee = returnVal
            break;
          default:
            this.$message.error('校验对象错误');
        }
      },

      /**
       * 清除输入框
       */
      clearForm() {
        this.formCarTypeData.addtypeId = '';
        this.formCarTypeData.addtypeName = '';
        this.formCarTypeData.addtypeLength = '';
        this.formCarTypeData.addtypeWidth = '';
        this.formCarTypeData.addtypeHeight = '';
        this.formCarTypeData.addtypeWeight = '';
        this.formCarTypeData.addtypeCarCost = null;
        this.formCarTypeData.addtypeInsurance = null;
        this.formCarTypeData.addtypeMaintenanceFees = null;
        this.formCarTypeData.addtypeChargingFee = null;
        this.formCarTypeData.addtypeInvoiceTax = null;
        this.formCarTypeData.addtypeDeposit = null;
        this.formCarTypeData.addtypeDailyFee = null;
        this.formCarTypeData.addtypeMonthlyFee = null;
        this.formCarTypeData.addtypeAnnualFee = null;
      },

      /**
       * 	确定按钮事件处理
       */
      createCarType() {
        this.check_inputs();
        if (this.dialogTitleType === 'create') {
          this.formCarTypeData.addtypeId = null;
          // console.log(!this.error_input);
          if (!this.error_input) {
            carTypeSave(this.formCarTypeData).then(res => {

              if (res.result === '1' || res.result === '2') {
                this.$message({
                  message: res.message,
                  type: 'info'
                })
                if (res.result === '1') {
                  this.carTypeDialogVisable = false;
                }
                this.setCarTypeList();

              } else {
                this.$message({
                  message: "网络异常，请重试",
                  type: 'info'
                })

              }
            })
          }
        } // create

        if (this.dialogTitleType === 'edit') {

          if (!this.error_input) {
            carTypeEdit(this.formCarTypeData).then(res => {
              if (res.result === '1' || res.result === '2') {
                this.$message({
                  message: res.message,
                  type: 'info'
                })
                if (res.result === '1') {
                  this.carTypeDialogVisable = false;
                }
                this.setCarTypeList();

              } else {
                this.$message({
                  message: "网络异常，请重试",
                  type: 'info'
                })

              }

            }) // carTypeEdit

          }
        }

      },

      /**
       * 删除操作
       */

      deleteCarType(row) {

        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCarTypeController(row.id).then(res => {

            if (res.result === '1' || res.result === '2') {
              this.$message({
                message: res.message,
                type: 'info'
              })
              this.setCarTypeList();

            } else {
              this.$message({
                message: "网络异常，请重试",
                type: 'info'
              })

            }
          }) // deleteCarTypeController
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },

      /**
       * 空值校验
       */
      check_inputs() {
        this.error_input = false;
        if (this.formCarTypeData.addtypeName === '') {
          this.$alert('类型名称不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeLength === '') {
          this.$alert('长度不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeWidth === '') {
          this.$alert('宽度不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeHeight === '') {
          this.$alert('高度不能为空')
          this.error_input = true
          return
        }
        if (this.formCarTypeData.addtypeWeight === '') {
          this.$alert('重量不能为空')
          this.error_input = true
          return
        }

      },

      /**
       * 编辑按钮事件处理
       */
      editCarType(row) {
        this.formCarTypeData.addtypeId = row.id;
        this.formCarTypeData.addtypeName = row.name;
        this.formCarTypeData.addtypeEntityId = row.entityId;
        this.formCarTypeData.addtypeLength = row.length;
        this.formCarTypeData.addtypeWidth = row.width;
        this.formCarTypeData.addtypeHeight = row.height;
        this.formCarTypeData.addtypeWeight = row.weight;
        this.formCarTypeData.addtypeCarCost = row.carCost;
        this.formCarTypeData.addtypeInsurance = row.insurance;
        this.formCarTypeData.addtypeMaintenanceFees = row.maintenanceFees;
        this.formCarTypeData.addtypeChargingFee = row.chargingFee;
        this.formCarTypeData.addtypeInvoiceTax = row.invoiceTax;
        this.formCarTypeData.addtypeDeposit = row.deposit;
        this.formCarTypeData.addtypeDailyFee = row.dailyFee;
        this.formCarTypeData.addtypeMonthlyFee = row.monthlyFee;
        this.formCarTypeData.addtypeAnnualFee = row.annualFee;
        this.dialogTitleType = 'edit';
        this.carTypeDialogVisable = true;
        this.enbleSelect = true
      },

      /**
       * 删除按钮事件处理
       */
      deleteCar(row) {

      }

    }, // methods

    mounted() {
      this.setCarTypeList();

    }
  }
</script>

<style>
  .input-type {
    float: right;
    margin-right: 2%;
    margin-top: 20px;
    width: 200px;
    /* margin-right: 1%; */
  }

  .pagination_easy {
    margin-top: 20px;
    /* margin-left: 10px; */
  }

  /* // 去掉横线 */
  .el-table__row>td {
    border: none;
  }

  .btn-car-type {
    background-color: #94c8f9;
    border: none;
  }

  .btn-car-del {
    background-color: #bea1a1;
    border: none;
  }

  /* 去掉最下面的那一条线
  .el-table::before {
  	height: 0px;
  } */
</style>
